export default __webpack_public_path__ + "static/media/mobile.b69728fe.gif";